module.exports = __webpack_public_path__ + "static/img/step5.248951ea.jpg";